export default __webpack_public_path__ + "static/media/logo.72deffa7.svg";